module.exports = __webpack_public_path__ + "img/picpay.7880c12.png";